var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "popper-body" }, [
    _c("div", { staticClass: "container p-2" }, [
      _vm.isExternalService()
        ? _c("section", { staticClass: "provider-container" }, [
            _c("div", { staticClass: "col-md-10" }, [
              _vm._m(0),
              _c("div", { staticClass: "panel-resizable col-12" }, [
                _c("span", { staticClass: "text-nowrap font-weight-bold" }, [
                  _vm._v(" " + _vm._s(_vm.value.companyName) + " ")
                ])
              ])
            ]),
            _c("div", { staticClass: "col-md-10 mt-2" }, [
              _vm._m(1),
              _c("div", { staticClass: "panel-resizable col-12" }, [
                _c("span", { staticClass: "text-nowrap font-weight-bold" }, [
                  _vm._v(" " + _vm._s(_vm.value.municipalityName) + " ")
                ])
              ])
            ]),
            _c("div", { staticClass: "col-md-10 mt-2" }, [
              _vm._m(2),
              _c("div", { staticClass: "panel-resizable col-12" }, [
                _c("span", { staticClass: "text-nowrap font-weight-bold" }, [
                  _vm._v(" " + _vm._s(_vm.value.locationName) + " ")
                ])
              ])
            ]),
            _c("div", { staticClass: "col-md-10 mt-2" }, [
              _vm._m(3),
              _c("div", { staticClass: "panel-resizable col-12" }, [
                _c("span", { staticClass: "text-nowrap font-weight-bold" }, [
                  _vm._v(" " + _vm._s(_vm.value.disciplineName) + " ")
                ])
              ])
            ])
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col-md-12 mt-2 d-flex pr-0 justify-content-between" },
        [
          _c("div", { staticClass: "mr-2" }, [
            _vm._m(4),
            _c("div", { staticClass: "panel-resizable col-12" }, [
              _c("span", { staticClass: "text-nowrap font-weight-bold" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.value.studentName + " - " + _vm.value.studentSieId
                    ) +
                    " "
                )
              ])
            ])
          ]),
          _c("div", [
            _vm.isRemoveBtnVisible
              ? _c(
                  "button",
                  {
                    staticClass: "ab-btn btn-outline-danger mr-1",
                    on: {
                      click: function($event) {
                        return _vm.$emit("remove-admission", {
                          ..._vm.value,
                          index: _vm.index
                        })
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-times-circle" })]
                )
              : _vm._e(),
            !_vm.editMode && !this.isInOtherCompany
              ? _c(
                  "button",
                  {
                    staticClass: "ab-btn ab-btn-success",
                    on: {
                      click: function($event) {
                        return _vm.$emit("edit-admission", {
                          ..._vm.value,
                          index: _vm.index
                        })
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-edit" })]
                )
              : _vm._e()
          ])
        ]
      ),
      _c("div", { staticClass: "col-md-10 mt-2" }, [
        _vm._m(5),
        _c("div", { staticClass: "col-12" }, [
          _c("span", { staticClass: "text-nowrap" }, [
            _vm._v(" " + _vm._s(_vm.value.studentAge) + " ")
          ])
        ])
      ]),
      _c("div", { staticClass: "col-md-10 mt-2" }, [
        _vm._m(6),
        _c("div", { staticClass: "col-12" }, [
          _c("span", { staticClass: "text-nowrap" }, [
            _vm._v(" " + _vm._s(_vm.value.referralNumber) + " ")
          ])
        ])
      ]),
      _c("div", { staticClass: "col-md-12 mt-2" }, [
        _vm._m(7),
        _c("div", { staticClass: "col-12" }, [
          _c("span", [
            _vm._v(
              " " +
                _vm._s(_vm.value.schoolCode + " - " + _vm.value.schoolName) +
                " "
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "col-md-10 mt-2" }, [
        _vm._m(8),
        _c("div", { staticClass: "col-12" }, [
          _c("span", { staticClass: "text-nowrap" }, [
            _vm._v(" " + _vm._s(_vm.value.frequency) + " ")
          ])
        ])
      ]),
      _c("div", { staticClass: "col-md-10 mt-2" }, [
        _vm._m(9),
        _c("div", { staticClass: "col-12" }, [
          _c("span", { staticClass: "text-nowrap" }, [
            _vm._v(" " + _vm._s(_vm.value.modality) + " ")
          ])
        ])
      ]),
      _c("div", { staticClass: "col-md-12 mt-2 duration-container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "duration-container_label col-6" }, [
            _vm._m(10),
            _c("div", [
              _c("span", { staticClass: "text-nowrap" }, [
                _vm._v(" " + _vm._s(_vm.value.duration) + " ")
              ])
            ])
          ]),
          _c("div", { staticClass: "col-6" }, [
            _c("div", { staticClass: "pagination-container row" }, [
              _c("button", {
                staticClass: "fas fa-chevron-left col-2",
                attrs: { disabled: _vm.index <= 1 },
                on: {
                  click: function($event) {
                    return _vm.changeIndex(_vm.index - 1, _vm.index)
                  }
                }
              }),
              _c("div", { staticClass: "content col-5" }, [
                _c("span", [
                  _vm._v(" " + _vm._s(_vm.index) + " "),
                  _c("span", { staticStyle: { color: "#e2e2e2" } }, [
                    _vm._v(" / ")
                  ]),
                  _vm._v(" " + _vm._s(_vm.totalMounted) + " ")
                ])
              ]),
              _c("button", {
                staticClass: "fas fa-chevron-right col-2",
                attrs: { disabled: _vm.index >= _vm.totalMounted },
                on: {
                  click: function($event) {
                    return _vm.changeIndex(_vm.index + 1, _vm.index)
                  }
                }
              })
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "data-name" }, [_vm._v("Proveedor:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "data-name" }, [_vm._v("Municipio:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "data-name" }, [_vm._v("Lugar de Servicio:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "data-name" }, [_vm._v("Disciplina:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "data-name" }, [_vm._v("Estudiante:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "data-name" }, [_vm._v("Edad:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "data-name" }, [_vm._v("Numero de referido:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "data-name" }, [_vm._v("Escuela:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "data-name" }, [_vm._v("Frecuencia:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "data-name" }, [_vm._v("Modalidad:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("label", { staticClass: "data-name" }, [_vm._v("Duracion:")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }